import React from "react";
import VerticalPreview from "../vertical-preview/VerticalPreview";
import PortraitPreview from "../portrait-preview/PortraitPreview";
import LandscapePreview from "../landscape-preview/LandscapePreview";

const OrientationsTemplatePreview = ({
  isTemplateVideo,
  dimensionsPreview,
  templateInputProps,
  autoCroppingImage,
  orientationSelected,
  videoDuration,
  TemplateComponent,
  toggleEditionModal,
  toggleAdSelection,
  toggleAdSelectionEdition,
  setIsAdPreviewHovered,
  isAdPreviewHovered,
  isUsed,
  isDismissed,
  editedAd,
  userProfile
}) => {
  return (
    <>
      {orientationSelected === "vertical" && (
        <VerticalPreview
          id={"vertical-preview"}
          isTemplateVideo={isTemplateVideo}
          dimensionsPreview={dimensionsPreview}
          templateInputProps={templateInputProps}
          autoCroppingImage={autoCroppingImage}
          orientationSelected={orientationSelected}
          videoDuration={videoDuration}
          TemplateComponent={TemplateComponent}
          toggleEditionModal={toggleEditionModal}
          toggleAdSelection={toggleAdSelection}
          toggleAdSelectionEdition={toggleAdSelectionEdition}
          setIsAdPreviewHovered={setIsAdPreviewHovered}
          isAdPreviewHovered={isAdPreviewHovered}
          isUsed={isUsed}
          isDismissed={isDismissed}
          editedAd={editedAd}
          userProfile={userProfile}
        />
      )}
      {orientationSelected === "portrait" && (
        <PortraitPreview
          id={"portrait-preview"}
          isTemplateVideo={isTemplateVideo}
          dimensionsPreview={dimensionsPreview}
          templateInputProps={templateInputProps}
          autoCroppingImage={autoCroppingImage}
          orientationSelected={orientationSelected}
          videoDuration={videoDuration}
          TemplateComponent={TemplateComponent}
          toggleEditionModal={toggleEditionModal}
          toggleAdSelection={toggleAdSelection}
          toggleAdSelectionEdition={toggleAdSelectionEdition}
          setIsAdPreviewHovered={setIsAdPreviewHovered}
          isAdPreviewHovered={isAdPreviewHovered}
          isUsed={isUsed}
          isDismissed={isDismissed}
          editedAd={editedAd}
          userProfile={userProfile}
        />
      )}
      {orientationSelected === "landscape" && (
        <LandscapePreview
          id={"landscape-preview"}
          isTemplateVideo={isTemplateVideo}
          dimensionsPreview={dimensionsPreview}
          templateInputProps={templateInputProps}
          autoCroppingImage={autoCroppingImage}
          orientationSelected={orientationSelected}
          videoDuration={videoDuration}
          TemplateComponent={TemplateComponent}
          toggleEditionModal={toggleEditionModal}
          toggleAdSelection={toggleAdSelection}
          toggleAdSelectionEdition={toggleAdSelectionEdition}
          setIsAdPreviewHovered={setIsAdPreviewHovered}
          isAdPreviewHovered={isAdPreviewHovered}
          isUsed={isUsed}
          isDismissed={isDismissed}
          editedAd={editedAd}
          userProfile={userProfile}
        />
      )}
    </>
  );
};

export default OrientationsTemplatePreview;
